
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/ranking/[[...pathParams]]",
      function () {
        return require("private-next-pages/landing/ranking/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/ranking/[[...pathParams]]"])
      });
    }
  